if (!customElements.get('layout-switcher')) {
  customElements.define(
    'layout-switcher',
    class LayoutSwitcher extends HTMLElement {
      constructor() {
        super();

        this.layouts = {
          'grid-4': 'grid-commons grid-view-4-column collection-quick-add-bulk group',
          'grid-6': 'grid-commons grid-view-6-column collection-quick-add-bulk group',
          'list': 'list-view collection-quick-add-bulk group'
        };

        this.onButtonClick = this.handleButtonClick.bind(this);
        this.onKeyDown = this.handleKeyDown.bind(this);
        this.refreshLayout = this.refreshLayout.bind(this);
        this.storageKey = 'preferred_layout';
        this.defaultLayout = 'grid-4';
      }

      get grid() {
        if (!this._grid || !this._grid.isConnected) {
          this._grid = document.getElementById('product-grid');
        }
        return this._grid;
      }

      connectedCallback() {
        this.init();
        this.addEventListener('keydown', this.onKeyDown);

        this.observer = new MutationObserver(() => {
          this._grid = null; 

          if (this.grid) {
            const savedLayout = localStorage.getItem(this.storageKey) || this.defaultLayout;
            const layoutClasses = this.layouts[savedLayout].split(' ');
            
            const needsUpdate = !layoutClasses.every(className => this.grid.classList.contains(className));

            if (needsUpdate) {
              this.refreshLayout();
            }
          }
        });

        const containerToWatch = document.getElementById('product-grid-container') || document.body;
        this.observer.observe(containerToWatch, { childList: true, subtree: true });
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.removeEventListener('keydown', this.onKeyDown);
      }

      init() {
        this.buttons = Array.from(this.querySelectorAll('.view-btn'));

        if (this.buttons.length === 0) return;

        const savedLayout = localStorage.getItem(this.storageKey) || this.defaultLayout;
        this.setLayout(savedLayout);

        this.buttons.forEach((button) => {
          button.addEventListener('click', this.onButtonClick);
        });
      }

      handleKeyDown(event) {
        const buttons = this.buttons
        const totalButtons = buttons.length;

        if (totalButtons === 0) return;

        const currentIdx = buttons.indexOf(document.activeElement);
        if (currentIdx === -1) return;

        let nextIdx;
        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            nextIdx = (currentIdx + 1) % totalButtons;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            nextIdx = (currentIdx - 1 + totalButtons) % totalButtons;
            break;
          case 'Home':
            nextIdx = 0;
            break;
          case 'End':
            nextIdx = totalButtons - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        const nextBtn = buttons[nextIdx];
        if (nextBtn) {
          nextBtn.focus();
          const layout = nextBtn.dataset.layout;
          if (layout) {
            this.setLayout(layout);
          }
        }
      }

      refreshLayout() {
         const savedLayout = localStorage.getItem(this.storageKey) || this.defaultLayout;
         this.setLayout(savedLayout);
      }

      handleButtonClick(event) {
        const layout = event.currentTarget.dataset?.layout;
        
        if (layout) {
          this.setLayout(layout);
        } else {
          console.warn('Layout data attribute is missing on clicked element:', event.currentTarget);
        }
      }

      setLayout(layout) {
        const grid = this.grid;
        if (!grid) return;

        Object.values(this.layouts).forEach(classString => {
          grid.classList.remove(...classString.split(' '));
        });

        const classesToAdd = this.layouts[layout];
        if (classesToAdd) {
          grid.classList.add(...classesToAdd.split(' '));
        }

        const viewMode = layout.includes('grid') ? 'grid' : 'list';
        grid.setAttribute('data-view-mode', viewMode);

        this.buttons.forEach((btn) => {
          const isSelected = btn.dataset.layout === layout;
          btn.setAttribute('aria-checked', isSelected);
          btn.setAttribute('tabindex', isSelected ? '0' : '-1');
        });

        localStorage.setItem(this.storageKey, layout);
      }
    }
  );
}